var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c(
            "Card",
            { staticClass: "elevation-3", staticStyle: { width: "100%" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-center"
                },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      value: _vm.load,
                      "buffer-value": 0,
                      indeterminate: _vm.load == 0,
                      stream: true,
                      striped: ""
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-center"
                },
                [
                  _c("p", { staticClass: "my-3" }, [
                    _vm._v(" " + _vm._s(_vm.status) + " ")
                  ])
                ]
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }